export default "__VITE_ASSET__BfN89UhB__"